import { circle as s } from "@turf/turf";
const c = "feet", n = ({
  geolocation: e,
  properties: p = {},
  radius: t = 250,
  unit: r = c
}) => s([e.lng, e.lat], t, {
  steps: 2e3,
  units: r,
  properties: {
    ...p,
    radius: t,
    unit: r
  }
});
export {
  n as getCircleFeature
};
//# sourceMappingURL=index.es199.js.map
